import React, { useEffect } from 'react';
import './Hero1.css';

export default function Hero1() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.hero1 .animate-side');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="hero1">

      <h1 className="animate-side slide-left">DataHarbor</h1>

      <div className="hero1-1">
        <div className="hero1-2">

          <p className="animate-side slide-right">
            <strong>Dataharbor</strong> delivers all-in-one digital solutions built to scale your business. From custom 
            web and mobile app design to cloud-based POS, ERP systems, e-commerce platforms, and interactive digital 
            menus, we build the technology that powers modern commerce.
          </p>
        </div>
      </div>
    </section>
  );
}